'use client';

import NotFoundError from '@/components/error/not-found-error';

export default function NotFound() {
  return <NotFoundError />;
}
